import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  addFieldData,
  removeStepChildren,
  setItemBreadcrumbs,
  setReturnedValue,
  stopLoading
} from "../../actions";
import { fetcher } from "../../utils/fetcher";
import { getConsigns, saveAppointment } from "../../utils/appointment";
import { translator } from "../../utils/i18n";
import Tooltip from "@material-ui/core/Tooltip";
import { nextAppointments } from "../../utils/scenario/scnr2-fetcher";
import { DateTime } from "luxon";
import * as CalendarHelper from "../../utils/calendar";
import { DATE_FORMAT_INTL } from "../../utils/constants";
import "react-custom-scroll/dist/customScroll.css";
import AlertDialog from "../AlertDialog";
import VideocamIcon from "@material-ui/icons/Videocam";
import Moment from "moment";
import { getReturnedValue } from "../../utils/fetcher";
import { goToBeginning } from "../../utils/scenario-manager";
import AlertConsigns from "../AlertConsigns";
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  NativeSelect,
  styled,
  InputBase
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import "./styleAppointment.css";

const radioStyles = () => ({
  root: {
    "&$checked": {
      color: "#117BA2"
    }
  },
  checked: {}
});

const CustomRadio = withStyles(radioStyles)(Radio);

const BootstrapInput = styled(InputBase)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(3)
  },
  "& .MuiInputBase-input": {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #ced4da",
    fontSize: 16,
    padding: "10px 26px 10px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ].join(","),
    "&:focus": {
      borderRadius: 4,
      borderColor: "#80bdff",
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)"
    }
  }
}));

class ListAppointment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      appointment: "",
      fullAppointment: {},
      date: DateTime.local(),
      consigns: [],
      canPrevious: false,
      doctors: [],
      datafiltered: [],
      praticien: "",
      mobileData: "",
      pcData: "",
      dateActuMobile: DateTime.local().day,
      dateCalendarDispo: [],
      dateActuMois: "",
      firstDay: "",
      prationerId: ""
      // messageNoAppointment: ""
    };
    this.originalActiveStep = {};

    this.getRenderCalendarMobile = this.getRenderCalendarMobile.bind(this);
  }

  componentDidMount() {
    this.originalActiveStep = { ...this.props.activeStep };
    this.props.step.data.fetchSource &&
      this.props.fetchData(this.props.step.data.fetchSource);

    const screenWidth = window.innerWidth;
    if (screenWidth > 670) {
      const { firstDayWeek, lastDayWeek } = this.getFirstAndLastDayOfWeek(
        this.state.date
      );

      this.setState({ firstDay: firstDayWeek });

      fetcher()
        .get("ajax/rdv_disponible_calendar_ajax.php", {
          searchParams: {
            idprofession: getReturnedValue("profession"),
            idp: getReturnedValue("practitioner"),
            idtyperdv: getReturnedValue("appointmentType"),
            idlieux: getReturnedValue("appointmentLocation"),
            nbpersonne: getReturnedValue("nbPeople"),
            filtreall: getReturnedValue("fullSearch"),
            datedebutpush: firstDayWeek,
            datefinpush: lastDayWeek
          }
        })
        .then(response => response.json())
        .then(json => {
          this.setState({ mobileData: json });
          this.setState({ pcData: json });
          // const firstItem = Array.isArray(json) ? json[0] : json;
          // const hasError = firstItem.code_error;
          // if (hasError === 1) {
          //   this.setState({ messageNoAppointment: firstItem.messagealert });
          // } else {
          //   this.setState({ mobileData: json });
          //   this.setState({ pcData: json });
          // }
        })
        .catch(() => {
          alert("erreur");
        });
    } else {
      const { firstDay, lastDay } = this.getMonthDetails(
        this.state.date.month,
        this.state.date.year
      );
      this.setState({ firstDay: firstDay });

      fetcher()
        .get("ajax/rdv_disponible_calendar_ajax.php", {
          searchParams: {
            idprofession: getReturnedValue("profession"),
            idp: getReturnedValue("practitioner"),
            idtyperdv: getReturnedValue("appointmentType"),
            idlieux: getReturnedValue("appointmentLocation"),
            nbpersonne: getReturnedValue("nbPeople"),
            filtreall: getReturnedValue("fullSearch"),
            datedebutpush: firstDay,
            datefinpush: lastDay
          }
        })
        .then(response => response.json())
        .then(json => {
          this.setState({ mobileData: json });
          this.setState({ pcData: json });
        })
        .catch(() => {
          alert("erreur");
        });
    }

    fetcher()
      .get("ajax/widget_liste_praticien.php?", {
        searchParams: {
          idprofession: this.props.returnedValue.profession,
          idtyperdv: this.props.returnedValue.appointmentType,
          idlieux: this.props.returnedValue.appointmentLocation,
          all: 1
        }
      })
      .then(response => response.json())
      .then(json => {
        this.setState({
          doctors: json
        });
      })
      .catch(() => {
        alert("erreur");
      });

    if (this.state.consigns.length === 0) {
      const nowDate = Moment().format("YYYY-MM-DD");
      getConsigns(
        getReturnedValue("appointmentType"),
        getReturnedValue("appointmentLocation"),
        nowDate,
        getReturnedValue("practitioner"),
        true
      ).then(consigns => {
        this.props.stopLoading();
        if (consigns.length > 0) {
          this.setState({
            consigns: consigns,
            fullAppointment: {}
          });
        }
      });
    }
  }

  goToBeginning = () => {
    this.props.goToBeginning();
  };

  getAvailableAppointmentCalendarFilter = id => {
    const { firstDay, lastDay } = this.getMonthDetails(
      this.state.date.month,
      this.state.date.year
    );

    this.setState({ firstDay: firstDay });
    fetcher()
      .get("ajax/rdv_disponible_calendar_ajax.php", {
        searchParams: {
          idprofession: this.props.returnedValue.profession,
          idp: id,
          idtyperdv: this.props.returnedValue.appointmentType,
          idlieux: this.props.returnedValue.appointmentLocation,
          nbpersonne: this.props.returnedValue.nbPeople,
          filtreall: 1,
          datedebutpush: firstDay,
          datefinpush: lastDay
        }
      })
      .then(response => response.json())
      .then(json => {
        this.setState({
          datafiltered: json
        });
        this.setState({
          mobileData: json
        });

        this.setState({
          pcData: json
        });

        this.props.stopLoading();
      })
      .catch(() => {
        alert("erreur");
        this.props.stopLoading();
      });
  };

  getFirstAndLastDayOfWeek(dateString) {
    const date = new Date(dateString);
    const firstDay = new Date(date.setDate(date.getDate() - date.getDay() + 1));
    const lastDay = new Date(date.setDate(date.getDate() - date.getDay() + 7));

    const firstDayFormatted = firstDay.toISOString().split("T")[0];
    const lastDayFormatted = lastDay.toISOString().split("T")[0];

    return { firstDayWeek: firstDayFormatted, lastDayWeek: lastDayFormatted };
  }

  getAvailableAppointmentPCCalendarFilter = id => {
    const { firstDayWeek, lastDayWeek } = this.getFirstAndLastDayOfWeek(
      this.state.date
    );

    this.setState({ firstDay: firstDayWeek });

    fetcher()
      .get("ajax/rdv_disponible_calendar_ajax.php", {
        searchParams: {
          idprofession: this.props.returnedValue.profession,
          idp: id,
          idtyperdv: this.props.returnedValue.appointmentType,
          idlieux: this.props.returnedValue.appointmentLocation,
          nbpersonne: this.props.returnedValue.nbPeople,
          filtreall: 1,
          datedebutpush: firstDayWeek,
          datefinpush: lastDayWeek
        }
      })
      .then(response => response.json())
      .then(json => {
        this.setState({
          datafiltered: json
        });
        this.setState({
          mobileData: json
        });
        this.setState({
          pcData: json
        });
        this.props.stopLoading();

        this.setState({ date: DateTime.fromISO(firstDayWeek) });
      })
      .catch(() => {
        alert("erreur");
        this.props.stopLoading();
      });
  };

  componentWillUnmount() {
    const dataKey = this.props.step.data.keyValue;
    this.props.resetData(dataKey);
    this.props.removeStepChildren(this.originalActiveStep);
  }

  handleCloseConsigns = () => {
    this.setState({ consigns: [] });
  };

  getData = date => {
    const stepData = this.props.step.data;
    const dataKey = stepData.keyValue;
    if (this.props.dataSource && this.props.dataSource[dataKey]) {
      let data = this.props.dataSource[dataKey];
      if (this.state.datafiltered.length != 0) {
        data = this.state.datafiltered;
      }
      if (data) {
        if (Object.values(data)[0].success === 0 && stepData.formatNoSource) {
          data = stepData.formatNoSource(data, date);
        } else if (stepData.formatSource) {
          const keys = Object.keys(data);

          keys.forEach(key => {
            data[key].forEach((elem, index) => {
              const parsedId = elem.id.split("-");
              const locationId = parsedId[6];
              const appointmentType = parsedId[8];
              data[key][index]["locationId"] = locationId;
              data[key][index]["appointmentTypeId"] = appointmentType;
            });
          });
          data = stepData.formatSource(data, date);
        }
      }
      return data;
    }
    if (this.props.message) {
      return this.props.message;
    }
    return null;
  };

  getDataMobile = date => {
    const stepData = this.props.step.data;
    const dataKey = stepData.keyValue;
    if (this.props.dataSource && this.props.dataSource[dataKey]) {
      let data = this.state.mobileData;
      if (this.state.datafiltered.length != 0) {
        data = this.state.datafiltered;
      }
      if (data) {
        if (Object.values(data)[0].success === 0 && stepData.formatNoSource) {
          data = stepData.formatNoSource(data, date);
        } else if (stepData.formatSource) {
          const keys = Object.keys(data);

          keys.forEach(key => {
            data[key].forEach((elem, index) => {
              const parsedId = elem.id.split("-");
              const locationId = parsedId[6];
              const appointmentType = parsedId[8];
              data[key][index]["locationId"] = locationId;
              data[key][index]["appointmentTypeId"] = appointmentType;
            });
          });
          data = stepData.formatSource(data, date);
        }
      }
      return data;
    }
    if (this.props.message) {
      return this.props.message;
    }
    return null;
  };

  getDataPC = date => {
    const stepData = this.props.step.data;
    const dataKey = stepData.keyValue;
    if (this.props.dataSource && this.props.dataSource[dataKey]) {
      let data = this.state.pcData;
      if (this.state.pcData.length != 0) {
        data = this.state.pcData;
      }
      if (data) {
        if (Object.values(data)[0].success === 0 && stepData.formatNoSource) {
          data = stepData.formatNoSource(data, date);
        } else if (stepData.formatSource) {
          const keys = Object.keys(data);

          keys.forEach(key => {
            data[key].forEach((elem, index) => {
              const parsedId = elem.id.split("-");
              const locationId = parsedId[6];
              const appointmentType = parsedId[8];
              data[key][index]["locationId"] = locationId;
              data[key][index]["appointmentTypeId"] = appointmentType;
            });
          });
          data = stepData.formatSource(data, date);
        }
      }
      return data;
    }
    if (this.props.message) {
      return this.props.message;
    }
    return null;
  };

  handleValidateConsigns = () => {
    this.setState({ consigns: [] });
    if (this.state.appointment !== "") {
      const helpRdv =
        this.state.fullAppointment.infordvaide &&
        this.state.fullAppointment.infordvaide.decoupe_rdvfils
          ? this.state.fullAppointment.infordvaide.decoupe_rdvfils
          : "";
      this.props.setReturnedValue({
        appointment: this.state.appointment,
        rdvHelp: helpRdv
      });
      this.buildBreadcrumbs(this.state.fullAppointment.date);
      this.props.saveAppointment(this.state.fullAppointment);
    }
  };

  listerJoursMois = mois => {
    const nbJours = new Date(new Date().getFullYear(), mois, 0).getDate();
    const jours = [];
    for (let i = 1; i <= nbJours; i++) {
      jours.push(
        new Date(new Date().getFullYear(), mois - 1, i).toDateString()
      );
    }

    return jours;
  };
  handleSelectChange = (id, praticien) => {
    this.setState({ praticien: praticien });
    this.getAvailableAppointmentCalendarFilter(id);
  };

  handleAppointmentClick = (event, appointment, date) => {
    const helpRdv =
      appointment.infordvaide && appointment.infordvaide.decoupe_rdvfils
        ? appointment.infordvaide.decoupe_rdvfils
        : "";
    const appointmentDate = Moment(appointment.dateaff, "DD/MM/YYYY").format(
      "YYYY-MM-DD"
    );
    getConsigns(
      appointment.appointmentTypeId,
      appointment.locationId,
      appointmentDate,
      appointment.id_long
    ).then(consigns => {
      this.props.stopLoading();
      if (consigns.length > 0) {
        this.setState({
          consigns: consigns,
          fullAppointment: appointment,
          appointment: appointment.id
        });
      } else {
        this.props.setReturnedValue({
          appointment: appointment.id,
          rdvHelp: helpRdv
        });
        this.buildBreadcrumbs(date);
        this.setState({ appointment: appointment.id });
        this.props.saveAppointment(appointment);
      }
    });
  };

  buildBreadcrumbs = value => {
    const element = { textItem: value, stepItem: { ...this.props.activeStep } };
    this.props.setBreadcrumbs(element);
  };

  getRenderCalendar = data => {
    const nbPeople = parseInt(this.props.returnedValue.nbPeople);
    const screenWidth = window.innerWidth;

    let textPeople =
      nbPeople > 1
        ? `${translator()._("W_POUR")} ${nbPeople} ${translator()._(
            "W_STEP4_BAS_LIST_PERSONNES"
          )}`
        : "";
    return (
      <div className="wrap-appointments-day" style={{ position: "relative" }}>
        {data &&
          data.map((item, key) => {
            return (
              <div
                key={key}
                className="appointments-day"
                style={{
                  width: "30px",
                  overflow: "visible",
                  position: "relative",
                  backgroundColor: "#ecf6fa"
                }}
              >
                <div className="title" style={{ position: "" }}>
                  {screenWidth > 670 ? (
                    <strong>{item.weekDay}</strong>
                  ) : (
                    <strong style={{ fontSize: "12px" }}>
                      {item.weekDay.substring(0, 3)}
                    </strong>
                  )}
                  {screenWidth > 670 ? (
                    item.date
                  ) : (
                    <strong style={{ fontSize: "12px" }}>{item.date}</strong>
                  )}
                </div>
                {item.list && (
                  <div
                    className="newcostumscrool"
                    style={{ position: "relative" }}
                  >
                    {item.list.map((itemHour, keyHour) => {
                      let textSecondary =
                        itemHour.activ_remplacant === "ok"
                          ? textPeople +
                            " " +
                            translator()._("CP_AVEC") +
                            " " +
                            itemHour.medecin +
                            " " +
                            translator()._("W_REMPLACANT") +
                            " " +
                            itemHour.nom_docteur_ref_princ
                          : textPeople;
                      if (this.props.returnedValue.practitioner === 0) {
                        textSecondary =
                          itemHour.activ_remplacant === "ok"
                            ? textPeople +
                              " " +
                              translator()._("CP_AVEC") +
                              " " +
                              itemHour.medecin +
                              " " +
                              translator()._("W_REMPLACANT") +
                              " " +
                              itemHour.nom_docteur_ref_princ
                            : textPeople +
                              " " +
                              translator()._("CP_AVEC") +
                              " " +
                              itemHour.medecin;
                      }
                      return (
                        <Tooltip
                          key={keyHour}
                          title={textSecondary}
                          placement="left-end"
                          className="item"
                        >
                          {screenWidth > 670 ? (
                            <div
                              style={{
                                position: "relative",
                                backgroundColor: "#117BA2",
                                color: "white",
                                padding: "5px",
                                display: "inline-block" // Pour que le bloc occupe seulement la largeur nécessaire
                              }}
                              onClick={event =>
                                this.handleAppointmentClick(
                                  event,
                                  itemHour,
                                  itemHour.date
                                )
                              }
                            >
                              {itemHour.heureaff_patient}
                              {nbPeople > 1 && (
                                <span className="nb-person">{nbPeople}</span>
                              )}
                              {itemHour.activ_remplacant === "ok" && (
                                <span
                                  style={{
                                    position: "absolute",
                                    top: "-10px",
                                    right: "-10px",
                                    backgroundColor: "red",
                                    color: "white",
                                    borderRadius: "50%", // Pour créer un cercle
                                    padding: "4px",
                                    fontSize: "11px"
                                  }}
                                >
                                  R
                                </span>
                              )}
                            </div>
                          ) : (
                            <div
                              style={{
                                position: "relative",
                                backgroundColor: "#117BA2",
                                color: "white",
                                padding: "5px",
                                display: "inline-block" // Pour que le bloc occupe seulement la largeur nécessaire
                              }}
                              onClick={event =>
                                this.handleAppointmentClick(
                                  event,
                                  itemHour,
                                  itemHour.date
                                )
                              }
                            >
                              {itemHour.heureaff_patient}
                              {nbPeople > 1 && (
                                <span className="nb-person">{nbPeople}</span>
                              )}
                              {itemHour.activ_remplacant === "ok" && (
                                <span
                                  style={{
                                    position: "absolute",
                                    top: "-10px",
                                    right: "-10px",
                                    backgroundColor: "red",
                                    color: "white",
                                    borderRadius: "50%", // Pour créer un cercle
                                    padding: "4px",
                                    fontSize: "11px"
                                  }}
                                >
                                  R
                                </span>
                              )}
                            </div>
                          )}
                        </Tooltip>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}

        {data &&
        data[0].success === 0 &&
        (data[0].message != "" || data[0].messagealert != "") &&
        screenWidth > 670 ? (
          <div
            style={{
              position: "absolute",
              bottom: 0,
              left: 0,
              width: "100%"
            }}
          >
            <div
              className="message-no-appointment"
              style={{
                minWwidth: "300px",
                marginBottom: 0,
                marginLeft: "auto",
                marginRight: "auto",
                padding: "5px 10px",
                backgroundColor: "#117BA2",
                color: "white",
                borderRadius: "25px",
                width: "60%",
                fontSize: "13px"
              }}
              onClick={() => {
                this.toAppointmentsPc(data[0].nextDate);
              }}
            >
              {data[0].message}
              <p style={{ marginTop: "2px", marginBottom: "2px" }}>
                {data[0]?.dateToShow}
              </p>
            </div>
          </div>
        ) : this.state.mobileData &&
          this.state.mobileData[0]?.success === 0 &&
          screenWidth < 670 ? (
          <div
            style={{
              position: "absolute",
              bottom: 0,
              left: 0,
              width: "100%"
            }}
          >
            <div
              className="message-no-appointment"
              style={{
                width: "200px",
                marginLeft: "auto",
                marginRight: "auto",
                backgroundColor: "#117BA2",
                color: "white",
                padding: "5px 15px",
                borderRadius: "25px",
                fontSize: "12px"
              }}
            >
              {this.state.mobileData[0]?.messagealert}
              <span>&#x202F; </span> {this.state.mobileData[0]?.dateaffiche}
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  };

  jourDeLaSemaineEnBaliseLi = numeroJour => {
    // Créer un tableau de jours de la semaine dans l'ordre
    const jours = [
      "lundi",
      "mardi",
      "mercredi",
      "jeudi",
      "vendredi",
      "samedi",
      "dimanche"
    ];

    // Vérifier si le numéro du jour est valide
    if (numeroJour >= 0 && numeroJour <= 6) {
      // Trouver le jour correspondant dans le tableau et renvoyer son index
      return jours.indexOf(jours[numeroJour]);
    } else {
      // Le numéro de jour est invalide, renvoyer -1
      return -1;
    }
  };
  getRenderCalendarMobile() {
    const { mobileData } = this.state;
    const finaldate = [];

    const keysData = Object.keys(mobileData);

    if (
      typeof mobileData[keysData[0]][0] !== "undefined" &&
      mobileData[keysData[0]][0]?.id
    ) {
      keysData.map(data => {
        mobileData &&
          mobileData[data].map(dataf => {
            const maChaine = dataf.dateaff;
            const regex = /^([^ ]+ ){2}(.*)$/;

            const resultat = maChaine.replace(regex, "$2");

            const regex2 = /^(\d{2})\//;

            const match = resultat.match(regex2);

            finaldate.push(match[1]);
          });
      });
    }

    const joursMois = this.listerJoursMois(this.state.date.month);

    const nexdate = this.state.date.plus({ months: 1 });
    const predate = this.state.date.minus({ months: 1 });
    const dateref = DateTime.local();
    const dateTimeObject = DateTime.fromISO(this.state.firstDay);
    const nj = this.jourDeLaSemaineEnBaliseLi(dateTimeObject.weekday - 1);
    const Jourvide = [];
    const screenWidth = window.innerWidth;

    for (let i = 0; i < nj; i++) {
      Jourvide.push(
        <li
          key={i + "dfdf"}
          style={{ flexBasis: "calc(100% / 9)", height: "22px" }}
        />
      );
    }

    return (
      <div
        style={{
          backgroundColor: "#ECF6FA",
          boxShadow: "1px 0px 3px #28282859",
          padding: "10px",
          position: "relative",
          width: "135%",
          height: "60vh",
          overflow: "scroll"
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            textAlign: "center",
            gap: "22px"
          }}
        >
          <div
            onClick={() =>
              dateref <= this.state.date && this.toAppointmentsMobile(predate)
            }
            disabled={true}
            className="prev"
            style={{}}
          >
            <i
              className="material-icons"
              style={{
                backgroundColor: "#117BA2",
                width: "30px",
                height: "30px",
                borderRadius: "160px",
                color: "white",
                lineHeight: "1.2"
              }}
            >
              navigate_before
            </i>
          </div>

          <div>
            <h2
              style={{
                fontSize: "16px",
                color: "#117BA2",
                fontWeight: "bold",
                width: "fit-content",
                margin: 0,
                marginTop: "5px",
                textTransform: "capitalize"
              }}
            >
              {this.state.date.toLocaleString({ month: "long" })}{" "}
              {this.state.date.year}
            </h2>
          </div>
          <div
            onClick={() => this.toAppointmentsMobile(nexdate)}
            className="next"
            style={{}}
          >
            <i
              className="material-icons"
              style={{
                backgroundColor: "#117BA2",
                width: "30px",
                height: "30px",
                borderRadius: "160px",
                color: "white",
                lineHeight: "1.2"
              }}
            >
              navigate_next
            </i>
          </div>
        </div>
        <ul
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            flexWrap: "wrap",
            listStyle: "none",
            padding: 0,
            gap: "7px"
          }}
        >
          <li style={{ flex: 1 }}>Lun</li>
          <li style={{ flex: 1 }}>Mar</li>
          <li style={{ flex: 1 }}>Mer</li>
          <li style={{ flex: 1 }}>Jeu</li>
          <li style={{ flex: 1 }}>Ven</li>
          <li style={{ flex: 1 }}>Sam</li>
          <li style={{ flex: 1 }}>Dim</li>
        </ul>
        <ul
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            listStyle: "none",
            padding: 0,
            gap: "3.5%"
          }}
        >
          {Jourvide}
          {joursMois.map((jour, key) => {
            const jourC = jour;
            const date = new Date(jourC).getDate();

            if (date) {
              if (date == this.state.dateActuMobile) {
                return (
                  <li
                    key={key}
                    style={{ flexBasis: "calc(100% / 9)", height: "26px" }}
                  >
                    <div
                      style={{
                        width: "27px",
                        color: "white",
                        fontSize: "15px",
                        lineHeight: "1.7",
                        marginLeft: "auto",
                        marginRight: "auto",
                        backgroundColor: "#117BA2",
                        borderRadius: "72px"
                      }}
                    >
                      {date}
                    </div>
                  </li>
                );
              } else if (finaldate.includes(date.toString())) {
                return (
                  <li
                    key={key}
                    style={{
                      flexBasis: "calc(100% / 9)",
                      height: "22px",
                      color: "#117BA2",
                      fontWeight: "bolder"
                    }}
                    onClick={() => this.setState({ dateActuMobile: date })}
                  >
                    {date}
                  </li>
                );
              } else {
                return (
                  <li
                    key={key}
                    style={{
                      flexBasis: "calc(100% / 9)",
                      height: "22px",
                      color: "#CACACA"
                    }}
                  >
                    {date}
                  </li>
                );
              }
            }
          })}
        </ul>
        <hr
          style={{
            width: "auto",
            height: "0.5px",
            backgroundColor: "#CACACA",
            border: "none",
            marginBottom: "5px"
          }}
        />
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "left",
            gap: "18px"
          }}
        >
          {typeof mobileData[keysData[0]][0] !== "undefined" &&
            keysData.map(data => {
              return (
                mobileData &&
                mobileData[data].map((dataf, key) => {
                  const regex = /^(\d{2})\//;

                  const match = dataf?.dateaff.match(regex);

                  if (match[1] == this.state.dateActuMobile) {
                    return (
                      <div
                        key={key}
                        style={{
                          backgroundColor: "#117BA2",
                          color: "white",
                          fontSize: "12px",
                          width: "56px",
                          height: "30px",
                          borderRadius: "4px",
                          lineHeight: "2.3"
                        }}
                        onClick={event =>
                          this.handleAppointmentClick(event, dataf, dataf.date)
                        }
                      >
                        {dataf?.heureaff_patient}
                      </div>
                    );
                  }
                })
              );
            })}
        </div>
        {this.state.mobileData &&
        this.state.mobileData[0]?.success === 0 &&
        screenWidth < 670 ? (
          <div
            style={{
              position: "absolute",
              bottom: 0,
              left: 0,
              width: "100%"
            }}
          >
            <div
              className="message-no-appointment"
              style={{
                width: "200px",
                marginLeft: "auto",
                marginRight: "auto",
                backgroundColor: "#117BA2",
                color: "white",
                padding: "5px 15px",
                borderRadius: "25px",
                fontSize: "12px"
              }}
              onClick={() =>
                this.toAppointmentsMobile(
                  DateTime.fromISO(this.state.mobileData[0]?.date)
                )
              }
            >
              {this.state.mobileData[0]?.messagealert}
              <span>&#x202F; </span> {this.state.mobileData[0]?.dateaffiche}
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
  getMonthDetails(month, year) {
    // Ajouter 1 au mois, car les mois en JavaScript sont indexés à partir de 0 (janvier = 0, février = 1, etc.)
    const adjustedMonth = month - 1;

    // Créer une nouvelle date en utilisant le premier jour du mois
    let firstDay = new Date(year, adjustedMonth, 1);
    const annee = firstDay.getFullYear();
    const mois = String(firstDay.getMonth() + 1).padStart(2, "0"); // Ajoute un zéro devant si le mois est inférieur à 10
    const jour = String(firstDay.getDate()).padStart(2, "0"); // Ajoute un zéro devant si le jour est inférieur à 10
    const dateFormatee = `${annee}-${mois}-${jour}`;

    firstDay = dateFormatee;

    // Récupérer le mois précédent en soustrayant 1 au mois actuel et en utilisant un jour précédent (0)
    const previousMonth = new Date(year, adjustedMonth, 0);

    // Récupérer le mois suivant en ajoutant 1 au mois actuel et en utilisant un jour précédent (0)
    let nextMonth = new Date(year, adjustedMonth + 1, 0);
    const annee2 = nextMonth.getFullYear();
    const mois2 = String(nextMonth.getMonth() + 1).padStart(2, "0"); // Ajoute un zéro devant si le mois est inférieur à 10
    const jour2 = String(nextMonth.getDate()).padStart(2, "0"); // Ajoute un zéro devant si le jour est inférieur à 10
    const dateFormatee2 = `${annee2}-${mois2}-${jour2}`;

    nextMonth = dateFormatee2;

    // Retourner les détails du mois sous forme d'objet
    return {
      firstDay,
      lastDay: nextMonth,
      lastDayPreviousMonth: previousMonth,
      lastDayNextMonth: nextMonth
    };
  }

  toAppointments = (date = null) => {
    let _canPrevious = true;
    // click on previous
    if (date === null) {
      // no more date available on the stack (aka first date)
      // so we stop call to API, maybe we need to "block" previous button
      if (CalendarHelper.size() === 0) {
        _canPrevious = false;
        return;
      }
      // when we arrive to first date we need to pop/add it to keep the "beginning" date
      // but we need to "block“ the previous button too
      if (CalendarHelper.size() === 1) {
        date = CalendarHelper.pop();
        _canPrevious = false;

        if (date.diff(this.state.date).toObject().milliseconds === 0) {
          return;
        }
      } else {
        date = CalendarHelper.pop();
        // in case of first click on previous, "poped" date is the same as displayed date
        // so we pop again. Not the more cleaner way to achieve this case
        if (date.diff(this.state.date).toObject().milliseconds === 0) {
          date = CalendarHelper.pop();
        }
      }
    } else {
      // click on next
      CalendarHelper.add(DateTime.fromISO(date));
    }
    date = DateTime.fromISO(date);
    this.setState({ date: date, canPrevious: _canPrevious });
    this.props.nextAppointments(date.toFormat(DATE_FORMAT_INTL));

    const { firstDayWeek } = this.getFirstAndLastDayOfWeek(this.state.date);
    this.setState({ firstDay: firstDayWeek });
  };

  toAppointmentsNew() {
    this.getAvailableAppointmentPCCalendarFilter(this.state.prationerId);
  }
  toAppointmentsMobile = date => {
    const { firstDay, lastDay } = this.getMonthDetails(date.month, date.year);

    fetcher()
      .get("ajax/rdv_disponible_calendar_ajax.php", {
        searchParams: {
          idprofession: getReturnedValue("profession"),
          idp: getReturnedValue("practitioner"),
          idtyperdv: getReturnedValue("appointmentType"),
          idlieux: getReturnedValue("appointmentLocation"),
          nbpersonne: getReturnedValue("nbPeople"),
          filtreall: getReturnedValue("fullSearch"),
          datedebutpush: firstDay,
          datefinpush: lastDay
        }
      })
      .then(response => response.json())
      .then(json => {
        this.setState({ mobileData: json });
        this.setState({ pcData: json });
        this.setState({ date: DateTime.fromISO(firstDay) });
        this.setState({ firstDay: firstDay });

        this.props.stopLoading();
      })
      .catch(() => {
        alert("erreur");
        this.props.stopLoading();
      });
  };

  toAppointmentsPc = date => {
    const { firstDayWeek, lastDayWeek } = this.getFirstAndLastDayOfWeek(date);

    fetcher()
      .get("ajax/rdv_disponible_calendar_ajax.php", {
        searchParams: {
          idprofession: getReturnedValue("profession"),
          idp: getReturnedValue("practitioner"),
          idtyperdv: getReturnedValue("appointmentType"),
          idlieux: getReturnedValue("appointmentLocation"),
          nbpersonne: getReturnedValue("nbPeople"),
          filtreall: getReturnedValue("fullSearch"),
          datedebutpush: firstDayWeek,
          datefinpush: lastDayWeek
        }
      })
      .then(response => response.json())
      .then(json => {
        this.setState({ mobileData: json });
        this.setState({ pcData: json });
        this.setState({ date: DateTime.fromISO(firstDayWeek) });
        this.setState({ firstDay: firstDayWeek });

        this.props.stopLoading();
      })
      .catch(() => {
        alert("erreur");
        this.props.stopLoading();
      });
  };

  editDate = date => {
    date = DateTime.fromISO(new Date(date).toISOString());
    this.setState({ date });
  };

  render() {
    const { step } = this.props;
    const data = this.getDataPC(this.state.date);
    const { praticien } = this.state;
    const { doctors } = this.state;
    const dataMobile = this.getDataMobile(this.state.date);

    const predate = this.state.date.minus({ days: 1 });

    if (step.label === "Sélectionnez votre RDV avec") {
      step.label = "Votre Rendez-vous";
    }

    const screenWidth = window.innerWidth;

    let nextDate = null;

    if (data) {
      const dataValues = Object.values(data);
      nextDate = dataValues[dataValues.length - 1].formattedDate;
      nextDate = nextDate.plus({ days: 1 });
    }

    const practitioner = this.props.returnedValue.practitioner || "";
    const getLabel = () => {
      if (practitioner === "0") {
        return step.label2 || "";
      }
      return <React.Fragment>{step.label}</React.Fragment>;
    };

    return (
      <>
        <div
          className="multiple-select-custom list-appointment"
          style={{ position: "relative" }}
        >
          <label className="label">
            <strong>{getLabel()}</strong>
            {this.props.typeConsultation === "teleconsult" && (
              <VideocamIcon className="icon-video" />
            )}
          </label>
          {data && (
            <div
              className="responsive-wrapper-calendar"
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "10px",
                borderRadius: "4px"
              }}
            >
              <div style={{ padding: "5px", width: "100%" }}>
                <h2
                  style={{
                    fontSize: "17px",
                    textAlign: "left",
                    marginBottom: "15px"
                  }}
                >
                  Choisissez votre praticien
                </h2>
                {screenWidth > 670 ? (
                  <div
                    style={{
                      width: "286px",
                      height: "auto",
                      minHeight: "100px",
                      backgroundColor: "#ECF6FA",
                      boxShadow: "1px 0px 3px #28282859",
                      padding: "10px",
                      textAlign: "center"
                    }}
                  >
                    <FormControl>
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue="première disponibilité"
                        name="radio-buttons-group"
                        sx={{ textAlign: "left", padding: 0 }}
                      >
                        <FormControlLabel
                          onClick={() => {
                            this.getAvailableAppointmentPCCalendarFilter("");

                            this.setState({ prationerId: "" });
                          }}
                          value="première disponibilité"
                          control={<CustomRadio size="small" />}
                          label="première disponibilité"
                        />
                        {doctors &&
                          doctors.map((value, key) => {
                            if (key === 0) {
                              return;
                            } else {
                              return (
                                <FormControlLabel
                                  onClick={() => {
                                    this.getAvailableAppointmentPCCalendarFilter(
                                      value.id
                                    );
                                    this.setState({ prationerId: value.id });
                                  }}
                                  value={value.praticien}
                                  control={<CustomRadio size="small" />}
                                  label={value?.nom_sms_user}
                                  key={key}
                                />
                              );
                            }
                          })}
                      </RadioGroup>
                    </FormControl>
                  </div>
                ) : (
                  <div
                    style={{
                      width: "97%"
                    }}
                  >
                    <FormControl
                      variant="standard"
                      fullWidth
                      style={{
                        borderStyle: "solid",
                        borderColor: "#949494",
                        borderRadius: "6px",
                        borderWidth: "1px",
                        width: "100%"
                      }}
                    >
                      <NativeSelect
                        value={praticien}
                        label="praticien"
                        onChange={e => {
                          this.handleSelectChange(
                            e.target.value,
                            e.target.praticien
                          );
                        }}
                        input={<BootstrapInput />}
                      >
                        <option
                          value=""
                          onClick={() =>
                            this.getAvailableAppointmentCalendarFilter("")
                          }
                        >
                          première disponibilité
                        </option>

                        {doctors &&
                          doctors.map((value, key) => {
                            return (
                              <option
                                value={value.id}
                                key={key}
                                onClick={() =>
                                  this.getAvailableAppointmentCalendarFilter(
                                    value.id
                                  )
                                }
                                style={{ textAlign: "left" }}
                              >
                                {value.praticien}{" "}
                              </option>
                            );
                          })}
                      </NativeSelect>
                    </FormControl>
                  </div>
                )}
              </div>
              {/* ///////////// */}
              <div style={{ margin: 0, padding: 0, width: "70%" }}>
                <h2
                  style={{
                    fontSize: "17px",
                    textAlign: "left",
                    marginBottom: "15px"
                  }}
                >
                  Date & heure
                </h2>
                {screenWidth > 670 ? (
                  <div
                    className="calendar-appointments"
                    style={{
                      backgroundColor: "#ECF6FA",
                      boxShadow: "1px 0px 3px #28282859",
                      padding: "10px",
                      position: "relative",
                      width: "100%",
                      minHeight: "150px",
                      maxHeight: "300px",
                      overflowY: "scroll"
                    }}
                  >
                    <div
                      onClick={() => this.toAppointmentsPc(predate)}
                      // disabled={!this.state.canPrevious}
                      className="prev"
                    >
                      <i
                        className="material-icons"
                        style={{
                          backgroundColor: "#117BA2",
                          width: "30px",
                          height: "30px",
                          borderRadius: "50%",
                          color: "white",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center"
                        }}
                      >
                        navigate_before
                      </i>
                    </div>
                    {this.getRenderCalendar(data)}
                    <div
                      style={{}}
                      onClick={() => this.toAppointmentsPc(nextDate)}
                      className="next"
                    >
                      <i
                        className="material-icons"
                        style={{
                          backgroundColor: "#117BA2",
                          width: "30px",
                          height: "30px",
                          borderRadius: "50%",
                          color: "white",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center"
                        }}
                      >
                        navigate_next
                      </i>
                    </div>
                  </div>
                ) : (
                  dataMobile && this.getRenderCalendarMobile(dataMobile)
                )}
              </div>
            </div>
          )}
        </div>
        {this.props.messageWithCode && this.props.messageWithCode.text && (
          <AlertDialog
            content={this.props.messageWithCode.text}
            isResetAlert={false}
          />
        )}
        {/* {this.state.messageNoAppointment == "" && (
          <AlertDialog
            content={this.state.messageNoAppointment}
            isResetAlert={true}
            onClick={this.goToBeginning}
          />
        )} */}
        {this.state.consigns.length > 0 && (
          <AlertConsigns
            handleClose={() => this.handleCloseConsigns()}
            consigns={this.state.consigns}
            onClick={() => this.handleValidateConsigns()}
            noCancel={this.state.appointment === ""}
          />
        )}
      </>
    );
  }
}

ListAppointment.propTypes = {
  activeStep: PropTypes.any,
  dataSource: PropTypes.any,
  fetchData: PropTypes.func,
  message: PropTypes.any,
  messageWithCode: PropTypes.shape({
    text: PropTypes.any
  }),
  nextAppointments: PropTypes.func,
  removeStepChildren: PropTypes.func,
  resetData: PropTypes.func,
  returnedValue: PropTypes.shape({
    nbPeople: PropTypes.any,
    profession: PropTypes.any,
    appointmentType: PropTypes.any,
    appointmentLocation: PropTypes.any,
    practitioner: PropTypes.string
  }),
  saveAppointment: PropTypes.func,
  setBreadcrumbs: PropTypes.func,
  setReturnedValue: PropTypes.func,
  step: PropTypes.shape({
    data: PropTypes.shape({
      fetchSource: PropTypes.func,
      formatNoSource: PropTypes.func,
      formatSource: PropTypes.func,
      keyValue: PropTypes.any
    }),
    icon: PropTypes.any,
    label: PropTypes.any,
    label2: PropTypes.string
  }),
  typeConsultation: PropTypes.string,
  stopLoading: PropTypes.func,
  goToBeginning: PropTypes.func
};

const mapStateToProps = state => {
  return {
    dataSource: state.dataSource,
    activeStep: state.activeStep,
    returnedValue: state.returnedValue,
    message: state.message,
    messageWithCode: state.messageWithCode,
    typeConsultation: state.returnedValue.typeConsultation
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchData: functionName => dispatch(functionName()),
    setReturnedValue: value => dispatch(setReturnedValue(value)),
    saveAppointment: appointment => dispatch(saveAppointment(appointment)),
    setBreadcrumbs: item => dispatch(setItemBreadcrumbs(item)),
    resetData: key => dispatch(addFieldData(key, null)),
    removeStepChildren: activeStep => dispatch(removeStepChildren(activeStep)),
    nextAppointments: date => dispatch(nextAppointments(date)),
    stopLoading: () => dispatch(stopLoading()),
    goToBeginning: () => dispatch(goToBeginning())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ListAppointment);
